// This gets added to the ol map obj
// called in share/php/asr/api/assessor-3.x.js

export default function(extent, padding = 0.1) {
  // if extent is no provided in function call, setting extent to map extent
  // would be incorrect if map proj != data proj, so throw error below
  // extent = extent || this.getView().getProjection().getExtent()
  if (!extent) {
    console.error('no extent in zoomToExtent()')
    return
  }
  const mapSize = this.getSize()
  if (mapSize[0] === 0 && mapSize[1] === 0) {
    console.error('rwg error: map has no size')
    return
  }
  const padHeight = mapSize[0] * padding
  const padWidth = mapSize[1] * padding
  const min = rwg.proj.transform(rwg.proj.dataSRID, rwg.proj.mapSRID, extent.slice(0,2).map(e => parseFloat(e)))
  const max = rwg.proj.transform(rwg.proj.dataSRID, rwg.proj.mapSRID, extent.slice(2).map(e => parseFloat(e)))
  const extentTransformed = min.concat(max).map(e => Math.round(e))

  this.getView().fit( extentTransformed, {
    size: mapSize,
    padding: [padHeight, padWidth, padHeight, padWidth], // top, right, bottom, left
  })
}
